import React from 'react';

export default function PrivacyPolicyIcon() {
  return (
   <svg className='ham-sub-menu-icon' viewBox='0 0 95.76 126.63'>
  <path
    fill='#ffff8b'
    d='M53.4,41.59h-11.33c-2.48,0-4.5,2.02-4.5,4.5v6.35h20.32v-6.35c0-2.48-2.02-4.5-4.5-4.5Z'
  />
  <path
    fill='#ffff8b'
    d='M91.92,12.07L49.29,.19c-.92-.26-1.9-.26-2.82,0L3.84,12.07c-2.27,.63-3.84,2.7-3.84,5.06v61.27c0,14.71,14.82,30.22,27.97,41.09,11.54,9.54,28.28,9.54,39.82,0,13.15-10.87,27.97-26.37,27.97-41.09V17.12c0-2.36-1.57-4.42-3.84-5.06Zm-16.46,70.09c0,4.81-3.9,8.71-8.71,8.71H28.72c-4.81,0-8.71-3.9-8.71-8.71v-21.01c0-4.81,3.9-8.71,8.71-8.71h.42v-6.35c0-7.13,5.8-12.92,12.93-12.92h11.33c7.13,0,12.93,5.8,12.93,12.92v6.35h.42c4.81,0,8.71,3.9,8.71,8.71v21.01Z'
  />
</svg>
  );
}


